module.exports = __webpack_public_path__ + "media/images/temp/icon-9-2d34dbd0242e69e2eb90402405038a2b.png";